import { render, staticRenderFns } from "./CtaAlternative.vue?vue&type=template&id=a95fee90"
import script from "./CtaAlternative.vue?vue&type=script&lang=js"
export * from "./CtaAlternative.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports